import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { trackHover } from 'documents-lib/js/tracking/tracker';
import { CLICK_DOWNLOAD } from 'documents-lib/js/tracking/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const DownloadHoverButton = ({
  name,
  deckId,
  downloadDocument
}) => /*#__PURE__*/_jsx(Button, {
  onClick: () => {
    trackHover({
      action: CLICK_DOWNLOAD,
      type: 'download'
    });
    downloadDocument({
      id: deckId,
      name
    });
  },
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.hoverButtons.download"
  })
});
export default DownloadHoverButton;